"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interval_overlap_p = exports.interval_not_overlap_p = void 0;
// NOTE [x0, x1] not overlap with [y0, y1]
function interval_not_overlap_p(x0, x1, y0, y1) {
    return y0 > x1 || y1 < x0;
}
exports.interval_not_overlap_p = interval_not_overlap_p;
// NOTE [x0, x1] overlap with [y0, y1]
function interval_overlap_p(x0, x1, y0, y1) {
    return !interval_not_overlap_p(x0, x1, y0, y1);
}
exports.interval_overlap_p = interval_overlap_p;
//# sourceMappingURL=interval.js.map